import { FeedbackType } from "./FeedbackType";
import { MFG } from "./MFG";

export class FeedbackCode {
  public constructor() {
    this.Code = "";
    this.Description = "";
    this.Manufacturer = new MFG();
    this.FeedbackTypeObject = new FeedbackType();
    this.MFGRowPointer = "";
  }

  public Code: string;
  public Description: string;
  public Manufacturer: MFG;
  public FeedbackTypeObject: FeedbackType;
  public MFGRowPointer: string;
}
